import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

const homeBatteryDomain = process.env.NEXT_PUBLIC_HOME_BATTERY_DOMAIN;
const websiteDomain = process.env.NEXT_PUBLIC_SITEMAP_HOST;

export default function B() {
    const { useLang, gtm, useRouter } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    const { t } = useLang(locale === 'de' ? 'home' : 'poweroceancollection');

    const gotoPage = (link: string, product_name: string, list_name: string, button_name: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'select_product',
            product_name,
            list_name,
            button_name,
        });
        window?.open(link);
        // router.push(link);
    };

    return (
        <div className={`ef-collection-pc-b ${css.efCollectionPCB}`}>
            <p className="title">{t('sec2_title')}</p>
            <div className="scene house">
                <p className="scene-name">{t('sec2_house')}</p>
                <div className="power-ocean panel">
                    <NextImage
                        webpSrc={require('@publicLocal/power-ocean/collection/pc/eu/2-1.webp')}
                        src={require('@publicLocal/power-ocean/collection/pc/eu/2-1.jpg')}
                        alt={t('sec2_title1')}
                        aria-label={t('sec2_title1')}
                    />
                    <div className="text-wrapper">
                        <p className="scene-title">{t('sec2_title1')}</p>
                        <p className="scene-desc">{t('sec2_desc1')}</p>
                        <div
                            className="learn-more"
                            onClick={() => gotoPage(`${homeBatteryDomain}/${locale}/products/PowerOcean`, t('sec2_title1'), t('sec2_house'), t('learn_more'))}
                        >
                            {t('learn_more')}
                        </div>
                    </div>
                </div>
                <div className="dc panel">
                    <NextImage
                        webpSrc={require('@publicLocal/power-ocean/collection/pc/eu/2-2.webp')}
                        src={require('@publicLocal/power-ocean/collection/pc/eu/2-2.jpg')}
                        alt={t('sec2_title2')}
                        aria-label={t('sec2_title2')}
                    />
                    <div className="text-wrapper">
                        <p className="scene-title small">{t('sec2_title2')}</p>
                        <p className="scene-desc">{t('sec2_desc2')}</p>
                        <div
                            className="learn-more"
                            onClick={() =>
                                gotoPage(`${homeBatteryDomain}${locale}/products/PowerOcean-DC-Fit`, t('sec2_title2'), t('sec2_house'), t('learn_more'))
                            }
                        >
                            {t('learn_more')}
                        </div>
                    </div>
                </div>
                <div className="delta panel">
                    <NextImage
                        webpSrc={require('@publicLocal/power-ocean/collection/pc/eu/2-3.webp')}
                        src={require('@publicLocal/power-ocean/collection/pc/eu/2-3.jpg')}
                        alt={t('sec2_title3')}
                        aria-label={t('sec2_title3')}
                    />
                    <div className="text-wrapper">
                        <p className="scene-title small">{t('sec2_title3')}</p>
                        <p className="scene-desc">{t('sec2_desc3')}</p>
                        <div
                            className="learn-more"
                            onClick={() =>
                                gotoPage(`${websiteDomain}/${locale}/delta-pro-portable-power-station`, t('sec2_title3'), t('sec2_house'), t('learn_more'))
                            }
                        >
                            {t('learn_more')}
                        </div>
                    </div>
                </div>
            </div>

            {locale !== 'uk' && (
                <div className="scene apartment">
                    <p className="scene-name">{t('sec3_apartment')}</p>
                    <div className="power-ocean panel">
                        <NextImage
                            webpSrc={require('@publicLocal/power-ocean/collection/pc/eu/2-4.webp')}
                            src={require('@publicLocal/power-ocean/collection/pc/eu/2-4.jpg')}
                            alt={t('sec3_title')}
                            aria-label={t('sec3_title')}
                        />
                        <div className="text-wrapper">
                            <p className="scene-title">{t('sec3_title')}</p>
                            <div
                                className="learn-more"
                                onClick={() => gotoPage(`${websiteDomain}/${locale}/powerstream`, t('sec3_title'), t('sec3_apartment'), t('learn_more'))}
                            >
                                {t('learn_more')}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="off-grid">
                <div className="panel">
                    <p className="scene-name">{t('sec4_off_grid')}</p>
                    <p className="scene-title">{t('sec4_title')}</p>
                    <div
                        className="learn-more"
                        onClick={() => gotoPage(`${websiteDomain}/${locale}/ecoflow-power-kits/series`, t('sec4_title'), t('sec4_off_grid'), t('learn_more'))}
                    >
                        {t('learn_more')}
                    </div>
                </div>
                <div className="panel">
                    <NextImage
                        webpSrc={require('@publicLocal/power-ocean/collection/pc/eu/2-5.webp')}
                        src={require('@publicLocal/power-ocean/collection/pc/eu/2-5.jpg')}
                        alt={t('sec4_title')}
                        aria-label={t('sec4_title')}
                    />
                </div>
                <div className="panel">
                    <NextImage
                        webpSrc={require('@publicLocal/power-ocean/collection/pc/eu/2-6.webp')}
                        src={require('@publicLocal/power-ocean/collection/pc/eu/2-6.jpg')}
                        alt={t('sec4_title')}
                        aria-label={t('sec4_title')}
                    />
                </div>
                <div className="panel">
                    <NextImage
                        webpSrc={require('@publicLocal/power-ocean/collection/pc/eu/2-7.webp')}
                        src={require('@publicLocal/power-ocean/collection/pc/eu/2-7.jpg')}
                        alt={t('sec4_title')}
                        aria-label={t('sec4_title')}
                    />
                </div>
            </div>
        </div>
    );
}
